import React from "react";
import "./CustomModal.css"; // Ensure this includes your new styles

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  isHideCloseButton?: boolean;
};

const CustomModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  isHideCloseButton,
}) => {
  return (
    <div className={`modal-overlay ${isOpen ? "open" : ""}`} onClick={onClose}>
      <div
        className={`modal-content ${isOpen ? "slide-in" : "slide-out"}`}
        onClick={(e) => e.stopPropagation()}>
        {!isHideCloseButton ? (
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        ) : null}
        {children}
      </div>
    </div>
  );
};

export default CustomModal;
